import React from 'react';
import { Text, Preset } from '@lux/text';
import { PhoneS, HelpS, ContactS } from '@lux/icons';
import { useTranslate } from '@pegasus/translation';
import { ContactItem, ContactText, StyledAnchor } from './styles';

export const CallUsItem = () => {
    const translate = useTranslate();

    // hotline unavailable in UK
    const isHotlineAvailable: boolean = window.APPDOMAIN_ID !== 43;

    return isHotlineAvailable ? (
        <ContactItem>
            <PhoneS />
            <ContactText>
                <Text preset={Preset.S}>{translate('contactUs.callUs')}</Text>
                <div />
                <Text preset={Preset.S}>{translate('contactUs.supportContactNumber')}</Text>
                <div />
                <Text preset={Preset.S}>{translate('contactUs.hotlineHours')}</Text>
            </ContactText>
        </ContactItem>
    ) : null;
};

export const HelpPageItem = () => {
    const translate = useTranslate();

    return (
        <ContactItem>
            <HelpS />
            <ContactText>
                <Text preset={Preset.S}>
                    <StyledAnchor href="/help">{translate('contactUs.helpPage')}</StyledAnchor>
                </Text>
            </ContactText>
        </ContactItem>
    );
};

export const EmailUsItem = () => {
    const translate = useTranslate();
    return (
        <ContactItem>
            <ContactS />
            <ContactText>
                <Text preset={Preset.S}>
                    <StyledAnchor href="/contact">
                        {translate('contactUs.sendEmailTitle')}
                    </StyledAnchor>
                </Text>
            </ContactText>
        </ContactItem>
    );
};
